/**
 * @author       denys.yefremov@gmail.com (Denys Yefremov)
 * @copyright    Copyright (c) 2022, Zumper
 */

import { staticUrl } from '@zcode/nr-utils'
import { getDeterministicRandomNumber } from '@zcode/utils'

export enum Size {
  thumbnail = 'thumbnail',
  small = 'small',
  hero = 'hero',
  largeHero = 'largeHero',
}

const noImagesList = ['red.svg', 'blue.svg', 'yellow.svg', 'house.svg']

export const getImagePlaceholder = (id: string | number, size: Size) => {
  const randomNumber = getDeterministicRandomNumber(id)
  return staticUrl(`img/noPics/${size}/${noImagesList[randomNumber]}`)
}
